import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Sparkles, ArrowRight } from "lucide-react";

export default function AuthPage() {
  const nav = useNavigate();
  const { login, register } = useAuth();
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = mode === "login" ? await login(email, password) : await register(email, password, username);
      toast.success(`Welcome, ${u.username}`);
      nav(u.role === "admin" ? "/admin" : "/scan");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Auth failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen jx-grid-bg flex flex-col items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-5">
          <div className="w-10 h-10 rounded-2xl jx-shutter flex items-center justify-center">
            <Sparkles size={18} className="text-slate-900" />
          </div>
          <span className="font-heading font-black text-2xl tracking-tight">Jixxeo Scan</span>
        </Link>
        <div className="jx-glass rounded-3xl p-6">
          <h1 className="font-heading text-2xl font-bold text-center">{mode === "login" ? "Sign in" : "Create account"}</h1>
          <p className="text-center text-slate-400 text-sm mt-1">Point. Tap. Discover.</p>
          <form onSubmit={submit} className="mt-5 space-y-3" data-testid="auth-form">
            {mode === "register" && (
              <input data-testid="auth-username" value={username} onChange={(e) => setUsername(e.target.value)}
                placeholder="Username" className="w-full h-12 px-4 rounded-xl bg-white/5 border border-white/10 outline-none focus:border-cyan-400/60" />
            )}
            <input data-testid="auth-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="Email" className="w-full h-12 px-4 rounded-xl bg-white/5 border border-white/10 outline-none focus:border-cyan-400/60" />
            <input data-testid="auth-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="Password" className="w-full h-12 px-4 rounded-xl bg-white/5 border border-white/10 outline-none focus:border-cyan-400/60" />
            <button data-testid="auth-submit" disabled={busy} type="submit"
              className="w-full h-12 rounded-xl bg-cyan-400 text-slate-950 font-semibold flex items-center justify-center gap-2 active:scale-95 disabled:opacity-60">
              {busy ? "…" : (mode === "login" ? "Sign in" : "Create account")} <ArrowRight size={16} />
            </button>
          </form>
          <button data-testid="auth-toggle" onClick={() => setMode(mode === "login" ? "register" : "login")}
            className="w-full mt-4 text-sm text-slate-400 hover:text-cyan-300">
            {mode === "login" ? "No account? Create one" : "Already registered? Sign in"}
          </button>
        </div>
        <p className="text-center text-[11px] text-slate-500 mt-4 font-mono-data uppercase tracking-widest">jixxeoscan.com</p>
      </div>
    </div>
  );
}
